export default __webpack_public_path__ + "static/media/Twitter.e8c66ae5.png";